import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    private auth: AngularFireAuth,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.auth.user.subscribe((user: any) => user && this.router.navigateByUrl('/dashboard'));
  }

  login (): any {
    this.auth.signInWithPopup(new auth.GoogleAuthProvider).then((_: any) => this.router.navigateByUrl('/dashboard')).catch((err: any) => console.log('Error signing in:', err));
  }

}
